const COUNTRY_LIST_SELECTOR = 'localization-form-component ul.countries';
const DEFERRED_TEMPLATE_ATTRIBUTE = 'data-nmvx-country-list-template';

function suspendCountryList(list) {
  if (!(list instanceof HTMLUListElement) || !list.isConnected) return;

  const template = document.createElement('template');
  template.setAttribute(DEFERRED_TEMPLATE_ATTRIBUTE, '');
  list.replaceWith(template);
  template.content.append(list);
}

function suspendCountryLists(root = document) {
  if (root instanceof Element && root.matches(COUNTRY_LIST_SELECTOR)) {
    suspendCountryList(root);
  }

  if (typeof root.querySelectorAll === 'function') {
    root.querySelectorAll(COUNTRY_LIST_SELECTOR).forEach(suspendCountryList);
  }
}

function hydrateLocalizationComponent(component) {
  if (!(component instanceof Element)) return;

  const form = component.matches('localization-form-component')
    ? component
    : component.querySelector('localization-form-component');

  if (!form) return;

  const template = form.querySelector(`template[${DEFERRED_TEMPLATE_ATTRIBUTE}]`);
  if (!(template instanceof HTMLTemplateElement)) return;

  template.replaceWith(template.content);

  if (typeof form.updatedCallback === 'function') {
    form.updatedCallback();
  }
}

function hydrateFromEvent(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const component = target.closest(
    'localization-form-component, dropdown-localization-component, drawer-localization-component'
  );
  hydrateLocalizationComponent(component);
}

suspendCountryLists(document);

document.addEventListener('pointerdown', hydrateFromEvent, true);
document.addEventListener('focusin', hydrateFromEvent, true);
document.addEventListener('click', hydrateFromEvent, true);
document.addEventListener(
  'keydown',
  (event) => {
    if (event.key === 'Enter' || event.key === ' ') hydrateFromEvent(event);
  },
  true
);

document.addEventListener('shopify:section:load', (event) => {
  suspendCountryLists(event.target);
});
